import React from 'react'
import { cn } from '@/lib/utils'
import { AsyncContentProgress } from '@/shared/ui'
import { useUserDateFormatter } from '@/modules/auth/hooks/useUserTimezone'
import { useTimelineAnalyses } from '../hooks/useTimelineAnalyses'
import { AnalysisPostPreviewCard } from './AnalysisPostPreviewCard'
import { AnalysisCardAuthorMeta } from './AnalysisCardAuthorMeta'

type AnalysisTimelineHistoryProps = {
  timelineRootId: number | null
  className?: string
}

export function AnalysisTimelineHistory({
  timelineRootId,
  className,
}: AnalysisTimelineHistoryProps) {
  const safeRootId =
    timelineRootId != null && Number.isFinite(Number(timelineRootId))
      ? Math.floor(Number(timelineRootId))
      : null
  const { formatUserDateTime } = useUserDateFormatter()
  const { items, loading, error } = useTimelineAnalyses(safeRootId, safeRootId != null)

  if (safeRootId == null) return null

  if (loading) {
    return (
      <div className="rounded-xl bg-background/20 p-3">
        <AsyncContentProgress loading label="Carregando historico da timeline...">
          {null}
        </AsyncContentProgress>
      </div>
    )
  }

  if (error) {
    return (
      <div className="rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-200">
        Nao foi possivel carregar o historico da timeline.
      </div>
    )
  }

  if (items.length <= 1) return null

  return (
    <div className={cn('relative pl-8', className)}>
      <div className="absolute left-3 top-0 h-full w-px bg-border/40" />
      <div className="space-y-6">
        {items.map((analysis) => (
          <div key={analysis.id} className="relative">
            <div className="absolute -left-[17px] top-6 h-3 w-3 rounded-full border border-border bg-[#1b1b1b]" />
            <AnalysisPostPreviewCard
              title={analysis.title}
              contentHtml={analysis.contentHtml}
              attachments={analysis.attachments}
              lightboxVariant="drawer"
              footer={(
                <div className="flex justify-end">
                  <AnalysisCardAuthorMeta
                    name={analysis.authorName}
                    avatarUrl={analysis.authorAvatarUrl}
                    dateLabel={analysis.createdAt ? formatUserDateTime(analysis.createdAt) : null}
                  />
                </div>
              )}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
